export default "__VITE_ASSET__DWo8FqUi__"